import { makeClientId, makeMassGov, makeMassGovB2C, makeMsauthRedirectURI } from './components/Utils'

export const authority = makeMassGov()
export const msalConfig = {
  auth: {
    clientId: makeClientId(),
    authority,
    knownAuthorities: [makeMassGovB2C()],
    redirectUri: makeMsauthRedirectURI() + '/home',
    postLogoutRedirectUri: makeMsauthRedirectURI() + '/home',
    response_type: 'id_token',
    prompt: 'login'
  }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['openid', makeClientId()],
  // extraQueryParameters: { idps: 'aad', capp: 'dta'},
  extraQueryParameters: {},
  authority
}

export const postLogoutRedirectUri = {
  redirectUri: makeMsauthRedirectURI() + '/'
}
